type MatomoCommand = [string, ...unknown[]];

declare global {
  interface Window {
    _paq?: MatomoCommand[];
  }
}

function push(command: MatomoCommand): void {
  if (!import.meta.client) return;

  window._paq = window._paq || [];
  window._paq.push(command);
}

export function useMatomo() {
  function trackEvent(
    category: string,
    action: string,
    name?: string,
    value?: number,
  ): void {
    push(['trackEvent', category, action, name, value]);
  }

  function trackSiteSearch(
    keyword: string,
    category?: string | false,
    resultCount?: number,
  ): void {
    push(['trackSiteSearch', keyword, category || false, resultCount]);
  }

  function setUserId(userId: string): void {
    push(['setUserId', userId]);
  }

  function resetUserId(): void {
    push(['resetUserId']);
  }

  return {
    trackEvent,
    trackSiteSearch,
    setUserId,
    resetUserId,
  };
}
